import $ from "jquery";
import "./../styles/main.scss";
require('./woocommerce/Global');
require('./helpers/CookieConsent');
import inView from "in-view";
require("jquery.scrollto");
import { carouselWrapper } from "./helpers/CarouselWrapper";
$(document).ready(function () {
    carouselWrapper();
    $.extend($.scrollTo.defaults, {
        axis: 'y'
    });
    if ($("#cases").length) {
        var casesContent_1 = $('#cases').children('.content');
        var closeCase = casesContent_1.children(".close").children("a");
        var ulListed_1 = $('#cases > .header > ul');
        var subNavList_1 = $('.list-nav');
        function openCase(id, index) {
            $('.case').hide();
            subNavList_1.children("li").removeClass("active");
            subNavList_1.children(".first-element").addClass("active");
            casesContent_1.slideDown(200);
            casesContent_1.find(id).slideDown(200);
            $("#cases").addClass("opened").attr("data-current", index);
            ulListed_1.children(".current").removeClass("current");
            ulListed_1.children("li:eq(" + (index - 1) + ")").addClass("current");
            $.scrollTo(ulListed_1.offset().top, 400);
        }
        function closeCaseFn() {
            casesContent_1.slideUp(200);
            casesContent_1.find('.case').slideUp(200);
            $.scrollTo('#cases', 400);
            $("#cases").removeClass("opened").attr("data-current", "0");
            subNavList_1.children(".current").removeClass("current");
        }
        closeCase.on("click", function (e) {
            e.preventDefault();
            closeCaseFn();
        });
        $("#cases").on("click", ".header .buttonWrapper a, .header .action, .buttons .action.next", function (e) {
            e.preventDefault();
            openCase($(e.currentTarget).attr("href"), parseInt($(e.currentTarget).attr("href").replace("#case-", "")));
        });
        $("#cases.opened").on("click", ".header ul > li", function (e) {
            e.preventDefault();
            if ($(e.currentTarget).hasClass("current"))
                closeCaseFn();
            else
                openCase("#case-" + ($(e.currentTarget).index() + 1), $(e.currentTarget).index() + 1);
        });
    }
    if ($(".case-header").length) {
        var casesContent_2 = $('#cases').children('.content');
        var closeCase = casesContent_2.children(".close").children("a");
        var ulListed_2 = $('.case-header > ul');
        var subNavList_2 = $('.list-nav');
        function openCaseInvest(id, index) {
            $('.case').hide();
            subNavList_2.children("li").removeClass("active");
            subNavList_2.children(".first-element").addClass("active");
            casesContent_2.slideDown(200);
            casesContent_2.find(id).slideDown(200);
            setTimeout(function () {
                if (typeof (Event) === 'function') {
                    // modern browsers
                    window.dispatchEvent(new Event('resize'));
                }
                else {
                    // for IE and other old browsers
                    // causes deprecation warning on modern browsers
                    var evt = window.document.createEvent('UIEvents');
                    evt.initUIEvent('resize', true, false, window, 0);
                    window.dispatchEvent(evt);
                }
            }, 200);
            $("#cases").addClass("opened").attr("data-current", index);
            ulListed_2.children(".current").removeClass("current");
            ulListed_2.children("li:eq(" + (index - 1) + ")").addClass("current");
            $.scrollTo("#cases", 400);
        }
        function closeCaseFnInvest() {
            casesContent_2.slideUp(200);
            casesContent_2.find('.case').slideUp(200);
            $.scrollTo('.case-header', 400);
            $("#cases").removeClass("opened").attr("data-current", "0");
            subNavList_2.children(".current").removeClass("current");
        }
        closeCase.on("click", function (e) {
            e.preventDefault();
            closeCaseFnInvest();
        });
        $(".case-header").on("click", ".buttonWrapper a", function (e) {
            e.preventDefault();
            openCaseInvest($(e.currentTarget).attr("href"), parseInt($(e.currentTarget).attr("href").replace("#case-", "")));
        });
        $("#cases.opened").on("click", ".header ul > li", function (e) {
            e.preventDefault();
            if ($(e.currentTarget).hasClass("current"))
                closeCaseFnInvest();
            else
                openCaseInvest("#case-" + ($(e.currentTarget).index() + 1), $(e.currentTarget).index() + 1);
        });
    }
    inView.threshold(0.35);
    inView('.node-parent')
        .on('enter', function (el) {
        $('ul[data-id="' + $(el).attr("data-parent") + '"]').children('.active').removeClass("active");
        $('li[data-id="' + $(el).attr("id") + '"]').addClass("active");
    });
    $("body").on("click", "a[data-goto]", function (e) {
        e.preventDefault();
        var node = $(e.currentTarget).attr("href");
        if (node.length) {
            var posY = $(node).offset().top - $("#main-header").height();
            if (posY >= 0) {
                $.scrollTo(posY, 400);
            }
        }
    });
    $('body').on("click", ".shared-item", function (e) {
        e.preventDefault();
        window.open($(e.currentTarget).attr("href"), "", "width=500,height=350");
    });
    $("body").on("click", "#menu-switcher a", function (e) {
        e.preventDefault();
        $("#nav-main").toggleClass("show-menu");
        $(e.currentTarget).toggleClass("show-menu");
    });
    $("body").on("click", ".goTo", function (e) {
        var elm = $(e.currentTarget).attr("href");
        var posY = $(elm).offset().top;
        $.scrollTo(posY, 400);
    });
    var windowWidth = $(window).width();
    var windowHeight = $(window).height();
    $(window).resize(function () {
        windowWidth = $(window).width();
        windowHeight = $(window).height();
    });
    var mouseXpercentage = 0;
    var mouseYpercentage = 0;
    $(document).mousemove(function (event) {
        mouseXpercentage = Math.round(event.clientX / windowWidth * 100);
        mouseYpercentage = Math.round(event.clientY / windowHeight * 100);
        $('.node.image.dark.moved').css('background', 'radial-gradient(at ' + mouseXpercentage + '% ' + mouseYpercentage + '%, #265777, #1a1c32)');
    });
});
